exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".zui-button{color:#fff;font-size:.09375rem;line-height:.260417rem;border-radius:.03125rem;background:#f7931e;min-width:.989583rem;cursor:pointer;border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/px2rem-webpack-loader?{"baseDpr":1,"remUnit":192,"remPrecision":6,"forcePxComment":"px","keepComment":"no","remLimit":1,"exclude":{}}!./src/components/less/button.css
// module id = 928
// module chunks = 0